import { merge } from "lodash";

import hungerApi from "../../api/hunger.api";

import {
  deleteStorePlanAction,
  getAllStoreSMSStatusDetailAction,
  getStoreDetailAction,
  getStoreListAction,
  getStoreSMSStatusDetailAction,
  postSearchPaymentHistoryAction,
  postSearchPointHistoryAction,
  putStorePlanAction,
  putStoreTapPayCardAction,
} from "./storeActions";
import {
  DeleteStorePlanType,
  GetStoreDetailType,
  GetStoreListType,
  PostSearchPaymentHistoryType,
  PostSearchPointHistoryType,
  PutStorePlanType,
  PutStoreTapPayCardType,
  SearchConfig,
  StoreSMSDetail,
  TapPayCard,
} from "./storeTypes";

export const getStoreList = (): ThunkActionTypes => async (dispatch) => {
  try {
    const { data } = await hungerApi.get<GetStoreListType>("/api/v3/mgt/store");

    dispatch(getStoreListAction(data));
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getStoreDetail =
  (storeId: number | string): ThunkActionTypes =>
  async (dispatch) => {
    try {
      const { data } = await hungerApi.get<GetStoreDetailType>(
        `/api/v3/mgt/store/${storeId}`
      );

      dispatch(getStoreDetailAction(data));
    } catch (error: any) {
      throw new Error(error);
    }
  };

export const getAllStoreSMSStatusDetail =
  (): ThunkActionTypes => async (dispatch) => {
    const { data } = await hungerApi.get<StoreSMSDetail[]>(
      `/api/v3/mgt/storeSms`
    );
    dispatch(getAllStoreSMSStatusDetailAction(data));
  };

export const getStoreSMSStatusDetail =
  (storeId: number): ThunkActionTypes =>
  async (dispatch) => {
    const { data } = await hungerApi.get<StoreSMSDetail>(
      `/api/v3/mgt/storeSms/${storeId}`
    );
    dispatch(getStoreSMSStatusDetailAction(data));
  };

export const putStoreTapPayCard =
  (storeId: number | string, tapPayInfor: TapPayCard): ThunkActionTypes =>
  async (dispatch) => {
    try {
      const { data } = await hungerApi.put<PutStoreTapPayCardType>(
        `/api/v3/mgt/store/${storeId}/tapPayCard`,
        tapPayInfor
      );
      dispatch(putStoreTapPayCardAction(data));
    } catch (error: any) {
      throw new Error(error);
    }
  };

export const putStorePlan =
  (storeId: number | string, planId: number | string): ThunkActionTypes =>
  async (dispatch) => {
    try {
      const { data } = await hungerApi.put<PutStorePlanType>(
        `/api/v3/mgt/store/${storeId}/plan`,
        { planId }
      );
      dispatch(putStorePlanAction(data));
    } catch (error: any) {
      throw new Error(error);
    }
  };

export const postSearchPaymentHistory =
  (storeId: number | string, config?: SearchConfig): ThunkActionTypes =>
  async (dispatch) => {
    try {
      const _config = merge<{}, SearchConfig, SearchConfig>(
        {},
        {
          paging: { page: 1, pageSize: 20 },
          sorting: { sort: "DESC", sortFields: ["createdAt"] },
        },
        config!
      );
      const { data } = await hungerApi.post<PostSearchPaymentHistoryType>(
        `/api/v3/mgt/store/${storeId}/searchPaymentHistory`,
        _config
      );

      dispatch(postSearchPaymentHistoryAction(data));
    } catch (error: any) {
      console.error(error);
    }
  };

export const postSearchPointHistory =
  (storeId: number | string, config?: SearchConfig): ThunkActionTypes =>
  async (dispatch) => {
    try {
      const _config = merge<{}, SearchConfig, SearchConfig>(
        {},
        {
          paging: { page: 1, pageSize: 20 },
          sorting: { sort: "DESC", sortFields: ["createdAt"] },
        },
        config!
      );
      const { data } = await hungerApi.post<PostSearchPointHistoryType>(
        `/api/v3/mgt/store/${storeId}/pointHistory/search`,
        _config
      );

      dispatch(postSearchPointHistoryAction(data));
    } catch (error: any) {
      console.error(error);
    }
  };

export const postStoredPoint =
  (storeId: string, point: number): ThunkActionTypes =>
  async (dispatch) => {
    try {
      const { data } = await hungerApi.post<GetStoreDetailType>(
        `/api/v3/mgt/store/${storeId}/depositPoint`,
        { point }
      );
      dispatch(getStoreDetailAction(data));
    } catch (error: any) {
      console.error(error);
    }
  };

export const postToRepaySMS =
  (storeId: string): ThunkActionTypes =>
  async (_) => {
    await hungerApi.post(`/api/v3/mgt/storeSms/${storeId}`);
  };

export const deleteStorePlan =
  (storeId: number | string): ThunkActionTypes =>
  async (dispatch) => {
    try {
      const { data } = await hungerApi.delete<DeleteStorePlanType>(
        `/api/v3/mgt/store/${storeId}/plan`
      );
      dispatch(deleteStorePlanAction(data));
    } catch (error: any) {
      console.error(error);
    }
  };
